<template>
  <div class="scrollable only-y ">
      <div class="page-header">
        <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">
            <i class="mdi mdi-home-outline"></i>
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="card-base card-shadow--medium p-30">
        <el-row :gutter="50">
            <!--form-->
          <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="9" :xl="9">
            <h2>Datos de Unidad de Medida</h2>
            <el-form :model="form" ref="measure" status-icon label-width="150px" size="medium" class="demo-form"
              :rules="rules" :label-position="(innerWidth > 1300) ? 'left' : 'top'" v-loading="loadingForm">
              <el-form-item label="Abreviatura" prop="measure_abbreviation">
                <el-input v-model="form.measure_abbreviation" autocomplete="off" placeholder="Abreviatura de la Unidad de Medida" clearable>
                </el-input>
              </el-form-item>
              <el-form-item label="Descripción" prop="measure_description">
                <el-input v-model="form.measure_description" autocomplete="off" placeholder="Descripción de la Unidad de Medida" clearable>
                </el-input>
              </el-form-item>
  
              <el-form-item class="btn-actions">
                <el-button type="primary" @click="submitForm('measure')" :loading="loading" icon="el-icon-check"
                  v-if="!edit">Guardar</el-button>
                <el-button type="warning" @click="submitForm('measure')" :loading="loading" icon="el-icon-edit" v-else>
                  Actualizar</el-button>
                <el-button @click="resetForm('measure')" icon="el-icon-close">Cancelar</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <!-- grid -->
          <el-col :span="12" :xs="24" :sm="24" :md="12" :lg="15" :xl="15">
            <el-table
              :data="tableData.filter(data => !search || data.measure_description.toLowerCase().includes(search.toLowerCase()))"
              style="width: 100%; margin-top:20px;" height="500" v-loading="loadingTable">
              <el-table-column label="Abreviatura" prop="measure_abbreviation"></el-table-column>
              <el-table-column label="Descripción" prop="measure_description"></el-table-column>
              <!-- <el-table-column align="right"> -->
              <el-table-column align="right">
                <template slot="header" slot-scope="scope">
                  <el-input v-model="search" size="mini" placeholder="Digite la unidad de medida" />
                </template>
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                    <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"
                      circle></el-button>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                    <el-button v-can="['admin']" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"
                      icon="el-icon-delete" circle></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import { save, update, getAll, destroy } from "@/api/product/measures.js";
  export default {
    name: "ProductMeasure",
    data() {
      return {
        loading: false,
        loadingForm: false,
        loadingTable: false,
        edit: false,
        innerWidth: 0,
        labelPosition: "top",
        form: {
          id: "",
          measure_abbreviation: "",
          measure_description: "",
        },
        rules: {
            measure_abbreviation: [
            {
              required: true,
              message: "Campo obligatorio",
              trigger: "blur",
            },
          ],
            measure_description: [
            {
              required: true,
              message: "Campo obligatorio",
              trigger: "blur",
            },
          ],
        },
        tableData: [],
        search: "",
      };
    },
    methods: {
      submitForm(measure) {
        this.loading = true;
        this.$refs[measure].validate((valid) => {
          if (valid) {
            if (this.edit) {
              this.updateForm();
            } else {
              this.saveForm();
            }
          } else {
            this.loading = false;
            console.log("error submit!!");
            return false;
          }
        });
      },
      saveForm() {
        save(this.form)
          .then(({ data }) => {
            this.loading = false;
            if (data.code === 200) {
              this.getTableData();
              this.resetForm("measure");
            } else {
              this.$message.error("Error! " + data.error);
            }
          })
          .catch(function (error) {
            this.loading = false;
            console.log("Err: ", error);
          });
      },
     
      updateForm() {
        update(this.form)
          .then(({ data }) => {
            this.loading = false;
            if (data.code === 200) {
              this.getTableData();
              this.resetForm("measure");
            } else {
              this.$message.error("Error! " + data.error);
            }
          })
          .catch(function (error) {
            this.loading = false;
            console.log("Err: ", error);
          });
      },

      resetForm(formMeasure) {
        this.$refs[formMeasure].resetFields();
        this.loading = false;
        this.edit = false;
      },
      getTableData() {
        this.loadingTable = true;
        getAll()
          .then(({ data }) => {
            this.loadingTable = false;
            this.tableData = data;
          })
          .catch(function (error) {
            this.loadingTable = false;
            console.log(error);
          });
      },
  
      // table
      handleEdit(index, row) {
            this.form = {
              id: row.id,
              measure_abbreviation: row.measure_abbreviation,
              measure_description: row.measure_description
            };
            this.edit=true
      },
      handleDelete(index, row) {
        this.$confirm("Desea eliminar este registro?", "Atención!", {
          confirmButtonText: "Si",
          cancelButtonText: "Cancelar",
          type: "warning",
        }).then(() => {
        this.loadingTable = true;
          destroy(row.id)
            .then(({ data }) => {
              this.loadingTable = false;
              if (data.code === 200) {
                this.getTableData();
              } else {
                this.$message.error("Error al eliminar la unidad de medida");
              }
            })
            .catch(function (error) {
              this.loadingTable = false;
              console.log("Err: ", error);
            });
        })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Operación Cancelada",
            });
          });
      },
    },
    created() {
      this.getTableData();
    }
  };
  </script>
  
  <style lang="scss">  
  .el-icon-circle-check {
    color: #1cc529;
  }
    .btn-actions{
        margin-top: 20px;
    }
  </style>
  